import * as React from 'react';
import { scrollTo } from '../utils';

export function useScrollTo(elementId: string): () => void {
  const elementRef = React.useRef<HTMLElement | null>(null);

  React.useEffect(() => {
    elementRef.current = document.getElementById(elementId);
  }, []);

  return React.useCallback(() => scrollTo(elementRef.current), [elementRef.current]);
}
